<template>
  <div>
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <th>用户名</th>
          <th>昵称</th>
          <th>公司代码</th>
          <th>帐号类型</th>
        </tr>
      </thead>
      <tbody v-if="users.length">
        <tr v-for="user in users">
          <td>{{user.username}}</td>
          <td>{{user.nickname}}</td>
          <td>{{user.company_code}}</td>
          <td>{{getRoleDisplay(user.role)}}</td>
        </tr>
      </tbody>
      <div v-else class="row">
        <div class="mx-auto" style="width: 200px">
          <p>该公司暂时没有任何帐号</p>
        </div>
      </div>
    </table>
  </div>  
</template>

<script>
import RoleMixin from '@/mixins/role'

function loadData () {
  this.$http.get(`/api/companies/${this.$route.params.companyCode}/users`).then((response) => {
    this.users = response.data.data
  })
}

export default {
  name: 'company-users',
  mixins: [RoleMixin],
  data () {
    return {
      users: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData
  }
}
</script>